import { useContext, useEffect, useState } from "react";
import { StatusContext } from "../../../context/statusProvider";
import { getMerch } from "../../../services/merchManager/merchManagerActions";
import { MerchCard } from "../../../layouts/merchManager/components";
import { usePaginate } from "../../../hooks/usePaginate";

const LOCATIONS = [
  { label: "All locations", value: "all" },
  { label: "Melbourne", value: "melb" },
  { label: "Sydney", value: "syd" },
];

const MerchCatalogue = () => {
  const [merch, setMerch] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const { updateAPI } = useContext(StatusContext);
  const { showingItems, PaginateBtn } = usePaginate(merch, null, 8);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    getMerch({ setIsLoadingMerch: setIsLoading }).then((res) => {
      setMerch(res);
    });
  }, [updateAPI]);

  const filtered = merch.filter((m) => {
    const matchesSearch = m.item_name
      ?.toLowerCase()
      .includes(search.toLowerCase());

    const matchesLocation =
      filter === "all" ||
      m.storage_location?.toLowerCase() === filter.toLowerCase();

    return matchesSearch && matchesLocation;
  });

  return (
    <div className="container">
      <div className="max-w-full mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-16">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-secondary">
              Merchandise
            </h2>
            <p className="text-sm text-gray-400 mt-1">
              Browse available items and submit a request
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 items-center">
            {/* Search */}
            <div className="relative w-full sm:w-72">
              <svg
                className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              <input
                className="w-full pl-9 pr-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary transition-colors"
                placeholder="Search items…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {/* Location filter */}
            <select
              id="storage-location"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-colors"
            >
              {LOCATIONS.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {isLoading && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <div
                key={i}
                className="rounded-2xl bg-gray-100 dark:bg-gray-800 animate-pulse h-64"
              />
            ))}
          </div>
        )}

        {!isLoading && filtered.length === 0 && (
          <div className="flex flex-col items-center justify-center py-24 text-gray-300 dark:text-gray-600">
            <svg
              className="w-12 h-12 mb-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10"
              />
            </svg>
            <p className="text-sm">
              {search ? "No items match your search" : "No merch available yet"}
            </p>
          </div>
        )}

        {!isLoading && filtered.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {filtered.slice(0, showingItems).map((item) => (
              <MerchCard key={item.id} item={item} />
            ))}
          </div>
        )}
        <div className="flex justify-center">
          {filtered.length > 8 && <PaginateBtn />}
        </div>
      </div>
    </div>
  );
};

export default MerchCatalogue;
